import React from 'react';
import {connect} from "react-redux";

import {
    fetchStoresAndRetailers,
    fetchIposConfigurations,
    createIposConfiguration,
    updateIposConfiguration,
    deleteIposConfiguration
} from './reducer';

import IposConfiguration from "./IposConfiguration";
import CreateIposConfigModal from "./CreateIposConfigModal";

export class IposConfigManager extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            configModalVisible: false
        };
        this.showConfigModal = this.showConfigModal.bind(this);
        this.hideConfigModal = this.hideConfigModal.bind(this);
        this.createNewIposConfig = this.createNewIposConfig.bind(this);
    }

    showConfigModal() {
        this.setState({configModalVisible: true});
    }

    hideConfigModal() {
        this.setState({configModalVisible: false});
    }

    createNewIposConfig(config) {
        this.props.createIposConfiguration(config);
        this.hideConfigModal();
    }

    componentDidMount() {
        this.props.fetchStoresAndRetailers();
        this.props.fetchIposConfigurations();
    }

    render() {
        return (
            <div className="animated fadeIn" style={{fontSize: 'small'}}>
                <CreateIposConfigModal retailers={this.props.retailers}
                                  visible={this.state.configModalVisible}
                                  onSubmit={this.createNewIposConfig}
                                  onCancel={this.hideConfigModal}/>
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">IPOS-Konfiguration</h4>
                        <div className="row">
                            <div className="col-3">
                                {/*<SearchField className="mb-2 mr-sm-2 mb-sm-0"*/}
                                {/*             value={this.props.searchQuery}*/}
                                {/*             onCommit={this.handleQueryChange}/>*/}
                            </div>
                            <div className="col-9">
                                <button type="button" className="btn btn-light pull-right"
                                        onClick={this.showConfigModal}>
                                    <i className="fa fa-plus-circle"/>&nbsp;neue Konfiguration
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <th>Händler</th>
                                        <th>GLN</th>
                                        <th>Benutzername</th>
                                        <th>Passwort</th>
                                        <th></th>
                                        <th>Aktionen</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.props.iposConfigurations.map((config, index) => {
                                        return <IposConfiguration key={index}
                                                                  onCommit={(username, password) => this.props.updateIposConfiguration(config.retailer.gln, username, password)}
                                                                  deleteIposConfiguration={this.props.deleteIposConfiguration}
                                                                  retailerName={config.retailer.name}
                                                                  retailerGln={config.retailer.gln}
                                                                  username={config.username}
                                                                  password={config.encryptedPassword}
                                        />
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        iposConfigurations: state.retailer.get('iposConfigurations').toJS(),
        retailers: state.retailer.get('retailers').toJS()
    };
}

const ConnectedIposConfigManager =
    connect(mapStateToProps, {fetchStoresAndRetailers, fetchIposConfigurations, createIposConfiguration, updateIposConfiguration, deleteIposConfiguration})(IposConfigManager);

export default ConnectedIposConfigManager;



// WEBPACK FOOTER //
// ./src/admin/retailer/IposConfigManager.js